import React from 'react';
import ReceiptsList from './ReceiptsList';
import Filters from './Filters';

const SelectReceipt = ({
    receiptsFilterForm,
    setReceiptsFilterForm,
    receiptsData,
    ...props
}) => {

    const filteredReceiptsData = () => {
        const {
            receiptId = "",
            fromDate = "",
            toDate = "",
        } = receiptsFilterForm;

        const filteredReceipts = receiptsData?.filter((receipt) => {

            const matchesReceiptId = receiptId
                ? receipt.receiptId?.toString().includes(receiptId.toString())
                : true;

            let matchesDate = true;

            const receiptDate = new Date(receipt.receiptDate);
            const from = fromDate ? new Date(fromDate) : null;
            const to = toDate ? new Date(toDate) : null;

            matchesDate = (!from || receiptDate >= from) && (!to || receiptDate <= to);


            return matchesReceiptId && matchesDate;
        });

        return filteredReceipts;
    };



    return (
        <div className='a-card m-0 mt-3'>
            <div className='d-flex justify-content-between'>
                <h2>Choose a Receipt</h2>
                <Filters
                    receiptsFilterForm={receiptsFilterForm}
                    setReceiptsFilterForm={setReceiptsFilterForm}
                />
            </div>

            <ReceiptsList
                receiptsData={filteredReceiptsData()}
                {...props}
            />
        </div>
    );
}

export default SelectReceipt;